import ReactDOM from "react-dom/client";
import React from "react";
import {
	QrCodeValidator,
	QrCodeValidationResult,
} from "./qr-code-validator.component";
import { PaymentSlipDataInput } from "./qr-payment-helpers";

export const validateQrCodeRendering = (
	paymentSlipData: PaymentSlipDataInput
): Promise<QrCodeValidationResult> => {
	return new Promise((resolve) => {
		let hasResolved = false;

		const container = document.createElement("div");
		container.style.position = "absolute";
		container.style.left = "-9999px";
		container.style.top = "-9999px";
		container.style.visibility = "hidden";
		document.body.appendChild(container);

		const root = ReactDOM.createRoot(container);

		const cleanup = () => {
			try {
				root.unmount();
			} catch (error) {
				// Ignore unmount errors
			}
			if (container.parentNode) {
				document.body.removeChild(container);
			}
		};

		const handleValidationComplete = (result: QrCodeValidationResult) => {
			if (hasResolved) return;
			hasResolved = true;

			setTimeout(() => {
				cleanup();
				resolve(result);
			}, 0);
		};

		root.render(
			React.createElement(QrCodeValidator, {
				paymentSlipData,
				onValidationComplete: handleValidationComplete,
			})
		);

		setTimeout(() => {
			if (hasResolved) return;
			hasResolved = true;

			cleanup();
			resolve({
				success: false,
				renderError: "Validation timeout - QR-Code konnte nicht innerhalb von 5 Sekunden validiert werden",
			});
		}, 5000);
	});
};
